import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class PrimeraB2001 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 223; i <= 258; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kit_path: '/images/kits/todas/',
      kits: [],
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table1:[{'color':0,'shortname':'temuco', 'rivalName':'Dep. Temuco', 'pj':6, 'pg':4,'pe':1,'pp':1,'gf':7,'gc':3,'dif':4, 'pts':13},
	      {'color':0,'shortname':'vial', 'rivalName':'Fernández Vial', 'pj':6, 'pg':0,'pe':3,'pp':3,'gf':3,'gc':8,'dif':-5, 'pts':3},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':6, 'pg':2,'pe':1,'pp':3,'gf':6,'gc':5,'dif':1, 'pts':7},
	      {'color':0,'shortname':'osorno', 'rivalName':'Prov. Osorno', 'pj':6, 'pg':3,'pe':1,'pp':2,'gf':6,'gc':6,'dif':0, 'pts':10}],

	table2:[{'color':0,'shortname':'everton', 'rivalName':'Everton', 'pj':30, 'pg':11,'pe':7,'pp':12,'gf':37,'gc':42,'dif':-5, 'pts':45},
              {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pj':30, 'pg':10,'pe':9,'pp':11,'gf':38,'gc':46,'dif':-8, 'pts':43},
              {'color':0,'shortname':'ovalle', 'rivalName':'Dep. Ovalle', 'pj':30, 'pg':10,'pe':7,'pp':13,'gf':43,'gc':51,'dif':-8, 'pts':43},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':30, 'pg':11,'pe':6,'pp':13,'gf':37,'gc':43,'dif':-6, 'pts':43},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':30, 'pg':13,'pe':9,'pp':8,'gf':36,'gc':34,'dif':2, 'pts':56},
              {'color':0,'shortname':'melipilla', 'rivalName':'Melipilla', 'pj':30, 'pg':7,'pe':9,'pp':14,'gf':30,'gc':43,'dif':-13, 'pts':33},
              {'color':'#295e1e','shortname':'cobresal', 'rivalName':'Cobresal', 'pj':30, 'pg':16,'pe':6,'pp':8,'gf':47,'gc':27,'dif':20, 'pts':59},
              {'color':0,'shortname':'magallanes', 'rivalName':'Magallanes', 'pj':30, 'pg':6,'pe':13,'pp':11,'gf':33,'gc':44,'dif':-11, 'pts':36},
              {'color':0,'shortname':'arica', 'rivalName':'Dep. Arica', 'pj':30, 'pg':7,'pe':10,'pp':13,'gf':40,'gc':44,'dif':-4, 'pts':33},
              {'color':0,'shortname':'osorno', 'rivalName':'Prov. Osorno', 'pj':30, 'pg':12,'pe':6,'pp':12,'gf':44,'gc':43,'dif':1, 'pts':47},
              {'color':0,'shortname':'naval', 'rivalName':'Dep. Talcahuano', 'pj':30, 'pg':13,'pe':7,'pp':10,'gf':40,'gc':32,'dif':8, 'pts':53},
              {'color':0,'shortname':'vial', 'rivalName':'Fernández Vial', 'pj':30, 'pg':15,'pe':8,'pp':7,'gf':44,'gc':34,'dif':10, 'pts':55},
              {'color':'#295e1e','shortname':'temuco', 'rivalName':'Dep. Temuco', 'pj':30, 'pg':18,'pe':6,'pp':6,'gf':64,'gc':31,'dif':33, 'pts':67},
              {'color':'#ff3355','shortname':'linares', 'rivalName':'Dep. Linares', 'pj':30, 'pg':6,'pe':9,'pp':15,'gf':37,'gc':54,'dif':-17, 'pts':30},
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':30, 'pg':11,'pe':11,'pp':8,'gf':47,'gc':39,'dif':8, 'pts':46},
              {'color':0,'shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':30, 'pg':7,'pe':11,'pp':12,'gf':33,'gc':43,'dif':-10, 'pts':34}]
    };
  }

  componentDidMount() {
	this.getKits();
	let newtable = this.sortTable(this.state.table1);
                this.setState({table1:newtable});

	let newtable2 = this.sortTable(this.state.table2);
                this.setState({table2:newtable2});
	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}

sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}




render(){


  let subT = this.subText('#295e1e', 'Asciende a Primera A 2002');
  let subD = this.subText('#ff3355', 'Desciende a Tercera División 2002');
console.log(this.state.id_list)

  return(

	<div style={{textAlign: 'center' }}>
	 <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Primera B 2001</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Grupo 4 </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>

       <div> Cada equipo empieza la Segunda Fase con la mitad de los puntos obtenidos en la Primera Fase</div> 
	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subT}
	 {subD}
	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Primera B 2001</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Primera B 2001</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Primera B 2001" />
     </div>


  )
}

}
export default PrimeraB2001;
